<template>
  <el-dialog
    class="advise-dialog"
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="false"
    top="207px"
    width="504px">
    <div class="dialog-title">
      <p class="title">建议&反馈</p>
      <button class="dialog-title-close" @click="closeDialog">
        <i class="el-icon-close"></i>
      </button>
    </div>
    <div class="dialog-body">
      <p>感谢您使用华强芯城，请留下您宝贵的意见，我们一定会认真对待！</p>
      <textarea class="kf-textarea" :class="validError.includes('msg_content') ? 'valid_error' : ''" v-model="form.msg_content"></textarea>
      <input type="text" class="kf-text" :class="validError.includes('user_email') ? 'valid_error' : ''" placeholder="请输入邮箱或手机" v-model="form.user_email"/>
    </div>
    <div class="dialog-foot">
      <button class="confirm-btn" @click="handleSubmit">提交</button>
    </div>
  </el-dialog>
</template>
<script>
import { feedbackApi } from '@/api/index'
import qs from 'qs'

export default {
  data() {
    return {
      visible: false,
      form: {
        msg_content: '',
        user_email: ''
      },
      validError: []
    }
  },
  methods: {
    closeDialog() {
      this.visible = false
    },
    showFeedDialog() {
      this.form.msg_content = ''
      this.form.user_email = ''
      this.visible = true
    },
    handleSubmit() {
      if (this.formValid()) {
        feedbackApi(qs.stringify({ ...this.form }))
          .then(res => {
            if (res.status == 1) {
              this.$smtMessage({
                type: 'success',
                content: '提交成功'
              })
              this.visible = false
            } else {
              this.$smtMessage({
                type: 'error',
                content: '提交失败'
              })
            }
          })
          .catch(() => {
            this.$smtMessage({
              type: 'error',
              content: '提交异常'
            })
          })
      }
    },
    formValid() {
      let vaildStatus = true
      const validError = []
      const accountReg = /^([\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+|\d{11})$/
      if (this.form.msg_content == '' || this.form.user_email == '') {
        if (this.form.msg_content == '') {
          validError.push('msg_content')
        }
        if (this.form.user_email == '') {
          validError.push('user_email')
        }
        this.$smtMessage({
          type: 'error',
          content: '请填写信息！'
        })
        vaildStatus = false
      } else if (!accountReg.test(this.form.user_email)) {
        this.$smtMessage({
          type: 'error',
          content: '邮箱或手机格式不正确！'
        })
        validError.push('user_email')
        vaildStatus = false
      }
      this.validError = validError
      return vaildStatus
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #E5E5E5;
  .title {
    padding: 15px;
    font-weight: bold;
    color: #333333;
  }
  .dialog-title-close {
    width: 16px;
    height: 16px;
    font-size: 16px;
    font-weight: bold;
    outline: 0;
    border: 0;
    background-color: rgba($color: #000000, $alpha: 0);
    color: #999999;
    transform: translate(-10px, 0);
    &:hover {
      color: #c00;
    }
  }
}
.dialog-body {
  padding: 20px;
  .kf-textarea{
    display: block;
    height: 140px;
    padding: 10px;
    resize: none;
    margin: 10px 0;
    outline: none;
    font-size: 13px;
  }
  .kf-text {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
  }
  .kf-textarea, .kf-text {
    width: 440px;
    border: 1px solid #D8D7D7;
    &.valid_error {
      background-color: #ffebeb !important;
      border-color: #ffbdbe !important;
    }
  }
}
.dialog-foot {
  padding: 0 20px 20px;
  display: flex;
  justify-content: flex-end;
  .confirm-btn {
    width: auto;
    overflow: visible;
    display: inline-block;
    padding: 6px 12px;
    _margin-left: 5px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    background-image: none;
    border: 1px solid #c00;
    border-radius: 4px;
    user-select: none;
    color: #fff;
    background-color: #c00;
    &:hover {
      color: #fff;
      background-color: #ee2323;
    }
  }
}
</style>
<style lang="scss">
.advise-dialog .el-dialog {
  outline: 0px;
  background-color: #fff;
  border: 1px solid #c00;
  border-radius: 6px;
  outline: 0;
  font-size: 14px;
  color: #333;
  position: relative;
}
.advise-dialog .el-dialog__header {
  display: none;
}
.advise-dialog .el-dialog__body {
  padding: 0;
}
</style>
